import styles from 'components/icons/Icon.module.scss';
import { IconProps } from 'components/icons/Icons.types';
import React from 'react';

const HomeIcon: React.FC<IconProps> = ({
  className = '',
  size = 24,
  color = '#fffff0',
  fillColor = 'transparent',
  fillOpacity = 1,
  circleStrokeColor = '#fffff0',
}) => {
  const baseCls = `${styles.IconContainer} ${className}`;
  return (
    <div className={baseCls}>
      <svg width={size} height={size} viewBox="0 0 24 24" fill="transparent" xmlns="http://www.w3.org/2000/svg">
        <circle
          fill={fillColor}
          fillOpacity={fillOpacity}
          cx="12"
          cy="12"
          r="10.5"
          stroke={circleStrokeColor}
          strokeWidth={'1.5px'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7 7.2c0 .4-.3.6-.6.6-.4 0-.6-.3-.6-.6s.3-.6.6-.6c.4 0 .6.3.6.6Zm-.6 2.6c.4 0 .6-.3.6-.6s-.3-.6-.6-.6c-.4 0-.6.3-.6.6s.3.6.6.6Zm.6 6.3c0 .4-.3.6-.6.6-.4 0-.6-.3-.6-.6s.3-.6.6-.6c.4 0 .6.3.6.6Zm-.6-4.4c.4 0 .6-.3.6-.6 0-.4-.3-.6-.6-.6-.4 0-.6.3-.6.6 0 .4.3.6.6.6Zm2.5-4.4c0 .4-.3.6-.6.6s-.6-.3-.6-.6.3-.6.6-.6.6.3.6.6ZM12 9.8c.4 0 .6-.3.6-.6s-.3-.6-.6-.6-.6.3-.6.6.3.6.6.6Zm.6 6.3c0 .4-.3.6-.6.6s-.6-.3-.6-.6.3-.6.6-.6.6.3.6.6Zm1.3-8.2c.4 0 .6-.3.6-.6s-.3-.6-.6-.6-.6.3-.6.6.3.6.6.6Zm.6 1.3c0 .4-.3.6-.6.6s-.6-.3-.6-.6.3-.6.6-.6.6.3.6.6Zm-.6 7.6c.4 0 .6-.3.6-.6s-.3-.6-.6-.6-.6.3-.6.6.3.6.6.6ZM9.5 4.7c-1.1 0-1.9.8-1.9 1.9V16.7c0 1.1.8 1.9 1.9 1.9h5c1.1 0 1.9-.8 1.9-1.9V6.6c0-1.1-.8-1.9-1.9-1.9h-5Zm5 1.3h-5c-.4 0-.6.3-.6.6V16.7c0 .4.3.6.6.6h5c.4 0 .6-.3.6-.6V6.6c0-.4-.3-.6-.6-.6Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default HomeIcon;
